<template>
  <div id="onlineLearning">
    <!-- 教师课程 -->
    <div class="row">
      <combination :config="teacherCourseConfig" :dataList="onlineLearningDataList.teacherList"></combination>
    </div>

    <div class="row">
      <combination :config="studentCourseConfig" :dataList="onlineLearningDataList.studentList"></combination>
    </div>

    <div class="row">
      <combination :config="parentCourseConfig" :dataList="onlineLearningDataList.parentList"></combination>
    </div>

    <div class="row">
      <combination :config="platformCourseConfig" :dataList="onlineLearningDataList.platformList"></combination>
    </div>
  </div>
</template>


<script>
import carouselView from 'views/generalView/carouselView.vue'
import combination from '@/components/combination/combination'
import homeListConfig from './config/homeListConfig.js'
// import onlineLearningData from '../../config/onlineLearning/onlineLearning.config.js'

import { trainingIndex } from '@/service/api/methods/educationCloud';
import * as api_advertising from '@/service/api/methods/api_advertising'

export default {
  components:{
    carouselView,
    combination,
  },
  data(){
    return{
      // onlineLearningData : onlineLearningData,
      onlineLearningDataList:{
        studentList : [],
        parentList : [],
        platformList : [],
        teacherList : []
      },
      liveCourseConfig:homeListConfig.liveCourseConfig,
      teacherCourseConfig:homeListConfig.teacherCourseConfig,
      studentCourseConfig:homeListConfig.studentCourseConfig,
      parentCourseConfig:homeListConfig.parentCourseConfig,
      platformCourseConfig:homeListConfig.platformCourseConfig,
    }
  },
  created(){
    this.trainingIndex();
  },
  methods:{
    trainingIndex(){
      trainingIndex().then(
        res=>{
          if(res.code == 200){
            this.imgBaseUrl = res.baseUrl || '';
            for(let i in res.data){
              this.onlineLearningDataList[i] = this.$utils.processData(res.data[i],res.baseUrl);
            }
            this.onlineLearningDataList = res.data;
          }
        }
      )
    },
  },


}
</script>

<style lang="less" scoped>
#onlineLearning{
  .row:nth-child(odd){
    background: #F5F5F5;
  }
  .row:nth-child(even){
    background: #fff;
  }
  .container{
    width: 1200px;
  }
}
</style>


